import { createError } from '@common/neo.tax';
import { useContext } from 'react';

import { RdContextValue } from '../rd-context-provider.types';
import { RdContext } from '../RdContextProvider';

export const useRdContext = (): RdContextValue => {
  const { fiscalYear, fiscalYearId, isNowPastPeriodEndDate, period, periodName, product } = useContext(RdContext);
  if (!period || !fiscalYearId || !fiscalYear || !periodName || !product || isNowPastPeriodEndDate === undefined) {
    throw createError('UseRdContextError', 'No rd context found');
  }
  return { period, fiscalYearId, fiscalYear, periodName, product, isNowPastPeriodEndDate };
};
